import { css } from 'styled-components';
import { pxToRem } from '../../foundation/spacing/utils.js';

var TYPOGRAPHY_SIZE_MAP = {
  small: 'tiny',
  medium: 'small',
  large: 'medium'
};
var getTypographySize = function getTypographySize(size) {
  return TYPOGRAPHY_SIZE_MAP[size];
};
var getIconSize = function getIconSize(size) {
  switch (size) {
    case 'large':
      return css(["height:", ";width:", ";"], pxToRem(16), pxToRem(16));
    case 'small':
    case 'medium':
    default:
      return css(["height:", ";width:", ";"], pxToRem(12), pxToRem(12));
  }
};
var getContainerSize = function getContainerSize(size) {
  switch (size) {
    case 'large':
      return css(["height:", ";"], pxToRem(32));
    case 'small':
      return css(["height:", ";"], pxToRem(20));
    case 'medium':
    default:
      return css(["height:", ";"], pxToRem(24));
  }
};
var getContentContainerPadding = function getContentContainerPadding(size) {
  switch (size) {
    case 'large':
      return css(["padding:0 ", ";"], pxToRem(8));
    case 'small':
      return css(["padding:0 ", ";"], pxToRem(6));
    case 'medium':
    default:
      return css(["padding:0 ", ";"], pxToRem(8));
  }
};
var getChipActionPadding = function getChipActionPadding(size) {
  switch (size) {
    case 'large':
      return css(["padding:", " ", " ", " ", ";"], pxToRem(10), pxToRem(10), pxToRem(10), pxToRem(6));
    case 'small':
      return css(["padding:", " ", " ", " ", ";"], pxToRem(4), pxToRem(4), pxToRem(4), pxToRem(2));
    case 'medium':
    default:
      return css(["padding:", " ", " ", " ", ";"], pxToRem(6), pxToRem(6), pxToRem(6), pxToRem(4));
  }
};

export { getChipActionPadding, getContainerSize, getContentContainerPadding, getIconSize, getTypographySize };
